import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class BigMushroom3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.BIG_MUSHROOM3;
}

export default BigMushroom3PoiTileEntity;
